import { get as getCookie, remove as removeCookie, set as setCookie } from "es-cookie";

import { send } from "../../components/core/ajax";
import { getUser } from "../../components/core/user";

/** Nombre de la cookie donde se guarda la info de los mensajes. */
const INBOX_COOKIE_NAME = "imsInboxTray";

/** Número de milisegundos que indica el periodo de refresco de la mensajería */
const INBOX_CHECK_TIME = 30000;

/** Datos que se guardan en la cookie. */
interface InboxTray {
  /** Timestamp del último check realizado. */
  lastCheck: number;

  /** Número de mensajes sin leer. */
  unread: number;

  /** Código de usuario. */
  userCode: string;
}

/**
 * Recupera la información de la bandeja de entrada para el usuario logeado. En
 * caso de ir bien la petición, invoca el callback indicado.
 *
 * @param onSuccess el callback a invocar si ha ido bien
 */
function fetchInboxSummary(onSuccess: (n: number) => void) {
  send({
    url: "mail/summary",
    success: (data) => {
      /* Si viene con error, no hacemos nada.
       * redirectErrorForm viene del html antiguo y es a causa de la
       * caputra de excepciones.
       */
      if (data != null && typeof data.unreadMails === "number") {
        onSuccess(data.unreadMails);
      }
    },
  });
}

/**
 * Inicializa el icono con el número de mensajes sin leer.
 */
export function initializeTrayIcon(): void {
  const user = getUser();
  if (user == null) {
    removeCookie(INBOX_COOKIE_NAME);
  } else if ($("#ims-messages-tray").length > 0) {
    let inbox: InboxTray | undefined;

    /* Únicamente se actualiza si hay usuario y existe el icono en el menú. */
    const cookieStr = getCookie(INBOX_COOKIE_NAME);
    if (cookieStr != null) {
      inbox = JSON.parse(cookieStr);

      /* Comprobamos que la cookie del mail no corresponda a otro usuario.
       * Podría pasar si pertenece a una sesión vieja. */
      if (inbox?.userCode !== user.code) {
        removeCookie(INBOX_COOKIE_NAME);
      }
    }

    /* Si no hay cookie o es vieja, entonces hay que leer los datos antes de
     * actualizar el icono. Si no, se actualiza directamente. */
    if (inbox == null || inbox.lastCheck == null || inbox.lastCheck + INBOX_CHECK_TIME < new Date().getTime()) {
      fetchInboxSummary((unread) => {
        if (unread != null) {
          setCookie(
            INBOX_COOKIE_NAME,
            JSON.stringify({
              lastCheck: new Date().getTime(),
              unread,
              userCode: user.code,
            })
          );
          updateTrayIcon(unread);
        }
      });
    } else {
      updateTrayIcon(inbox.unread);
    }
  }
}

/**
 * Actualiza el icono de la bandeja de entrada que se encuentra en el menú.
 *
 * @param unread el número de mensajes sin leer
 */
export function updateTrayIcon(unread: number): void {
  if (unread != null) {
    const trayText = $("#ims-messages-tray-text");
    const label = unread === 1 ? trayText.attr("data-one-label") : trayText.attr("data-n-label");

    trayText.html(`${unread} ${label}`);
    $("#ims-messages-tray-badge").html(`${unread}`).css({ visibility: "visible" });
  }
}
